export default {"src":"/intl/_next/static/media/list.21499dd8.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};